import "./index.scss";
import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import IGFly from "../../assets/img/Featured/fly-tap-pay.png";
import OnDemand from "../../assets/img/Featured/app-ondemand-food.png";
import Book4Time from "../../assets/img/Featured/app-book4time-cabana.png";
import Reserve from "../../assets/img/Featured/app-reserve2.png";
import GuestApp from "../../assets/img/Featured/app-guest-dining.png";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";

const BeachPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page beachPage">
            <Header />
            <div className="page-header">Beach Front</div>
            <div className="text-wrapper">
                <div className="std-text">
                    Delight guests with food and beverage at-a-click
                    ordering delivered wherever they are. Enhance
                    the beach and cabana experience with fast, easy,
                    mobile ordering and payment to drive increased
                    order volume, improve check size and grow F&B
                    revenue.{'\n\n'}
                </div>
                <div className="std-text">
                    And ensure guests can enjoy their preferred
                    beach chair or cabana with online reservations
                    that keep them in the sun and relaxing.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Beach Page", "IG Fly");
                    addFlow("IG Fly");
                    navigate("/solutions/ig-fly")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Fly
                    </div>
                    <img src={IGFly} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Beach Page", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={OnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Beach Page", "Book4Time");
                    addFlow("Book4Time");
                    navigate("/solutions/book4time")}}>
                    <div className="item-head">
                        <LogoMini />
                        Book4Time
                    </div>
                    <img src={Book4Time} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Beach Page", "Reserve");
                    addFlow("Reserve");
                    navigate("/solutions/reserve")}}>
                    <div className="item-head">
                        <LogoMini />
                        Reserve
                    </div>
                    <img src={Reserve} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Beach Page", "Guest App");
                    addFlow("Guest App");
                    navigate("/solutions/guest-app")}}>
                    <div className="item-head">
                        <LogoMini />
                        Guest App
                    </div>
                    <img src={GuestApp} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default BeachPage;